export default __webpack_public_path__ + "40b33d734d69cafd9ca7b76d4514c723.svg";